import Bank from './Bank';
import Branches from '../components/Branches';
import ChevronEnd from './ChevronStart';
import ChevronStart from './ChevronEnd';
import Debug from './Debug';
import DotMenu from './DotMenu';
import DoubleChevron from './DoubleChevron';
import DragAndDrop from './DragAndDrop';
import Dropdown from './Dropdown';
import FontSize from './FontSize';
import Funda from './Funda';
import HouseAccepted from './HouseAccepted';
import HouseRejected from './HouseRejected';
import HtmlSquare from './HtmlSquare';
import HtmlTag from './HtmlTag';
import Hypotheekbond from '~/components/atom/Logo/components/Hypotheekbond';
import IncomingLink from './IncomingLink';
import IncomingUser from './IncomingUser';
import Indent from './Indent';
import Intercom from './Intercom';
import LeadScoreChange from './LeadScoreChange';
import Loading from './Loading';
import LongText from './LongText';
import MultiChoice from './MultiChoice';
import NumberedList from './NumberedList';
import Office from './Office';
import Outdent from './Outdent';
import OutgoingUser from './OutgoingUser';
import Pin from './Pin';
import Quote from './Quote';
import Redo from './Redo';
import RemoveStyle from './RemoveStyle';
import Reply from './Reply';
import RichText from './RichText';
import ShortText from './ShortText';
import SingleChoice from './SingleChoice';
import Spinner from './Spinner';
import TextBackground from './TextBackground';
import TextColor from './TextColor';
import TrustooEmblem from '~/components/atom/Logo/components/TrustooEmblem';
import Typography from './Typography';
import Undo from './Undo';

import {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  Anchor,
  ArrowDown,
  ArrowDownCircle,
  ArrowDownRight,
  ArrowLeft,
  ArrowRight,
  ArrowRightCircle,
  ArrowUp,
  AtSign,
  BarChart,
  Bell,
  Bold,
  BookOpen,
  Briefcase,
  Calendar,
  Camera,
  Check,
  CheckCircle,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
  ChevronUp,
  Circle,
  Clipboard,
  Clock,
  Copy,
  CornerDownRight,
  CornerRightDown,
  CreditCard,
  Crop,
  Delete,
  DollarSign,
  Droplet,
  Edit,
  Edit3,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileText,
  Flag,
  GitPullRequest,
  Globe,
  Grid,
  Hash,
  HelpCircle,
  Home,
  Image,
  Info,
  Italic,
  Key,
  Layers,
  Layout,
  Link,
  List,
  Lock,
  LogOut,
  Mail,
  Map,
  MapPin,
  Maximize,
  Menu,
  MessageSquare,
  Minimize,
  Minimize2,
  Minus,
  MinusSquare,
  Monitor,
  Pause,
  Phone,
  PhoneOutgoing,
  Play,
  Plus,
  PlusSquare,
  RefreshCcw,
  Repeat,
  RotateCcw,
  RotateCw,
  Save,
  Search,
  Send,
  Settings,
  Share,
  Shield,
  ShieldOff,
  Slash,
  Sliders,
  Square,
  Star,
  Tag,
  Trash2,
  Triangle,
  Truck,
  Type,
  Umbrella,
  Underline,
  Unlock,
  Upload,
  User,
  UserCheck,
  UserPlus,
  Users,
  UserX,
  Volume2,
  VolumeX,
  X,
  XCircle,
  Zap,
  ZoomIn,
  ZoomOut,
} from 'react-feather';
import NLFlag from './NLFlag';
import ENGFlag from './ENGFlag';
import FlipX from './FlipX';
import FlipY from './FlipY';
import AI from './AI';
import Feedback from './Feedback';
import WidgetIcon from './WidgetIcon';
import LfaCalendarIcon from './LfaCalendarIcon';
import CookiesLocked from './CookiesLocked';

export type Props = React.SVGAttributes<SVGElement> & {
  color?: string;
};

const icons = {
  'alert-circle': AlertCircle,
  'alert-octagon': AlertOctagon,
  'align-center': AlignCenter,
  'align-justify': AlignJustify,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  'arrow-down-circle': ArrowDownCircle,
  'arrow-down': ArrowDown,
  'arrow-right-circle': ArrowRightCircle,
  'bar-chart': BarChart,
  'book-open': BookOpen,
  'check-circle': CheckCircle,
  'check-square': CheckSquare,
  'chevron-end': ChevronEnd,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-start': ChevronStart,
  'chevron-up': ChevronUp,
  'chevrons-right': ChevronsRight,
  'cookies-locked': CookiesLocked,
  'credit-card': CreditCard,
  'dot-menu': DotMenu,
  'double-chevron': DoubleChevron,
  'drag-n-drop': DragAndDrop,
  'email-sign': AtSign,
  'ENG-flag': ENGFlag,
  'eye-closed': EyeOff,
  feedback: Feedback,
  'file-text': FileText,
  'flip-x': FlipX,
  'flip-y': FlipY,
  'font-size': FontSize,
  'house-accepted': HouseAccepted,
  'house-rejected': HouseRejected,
  'html-square': HtmlSquare,
  'html-tag': HtmlTag,
  'lead-score-change': LeadScoreChange,
  'lead-score': Star,
  'long-text': LongText,
  'map-pin': MapPin,
  'message-square': MessageSquare,
  'multi-choice': MultiChoice,
  'NL-flag': NLFlag,
  'numbered-list': NumberedList,
  'question-mark': HelpCircle,
  'remove-style': RemoveStyle,
  'rich-text': RichText,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  'shield-off': ShieldOff,
  'short-text': ShortText,
  'sign-out': LogOut,
  'single-choice': SingleChoice,
  'text-background': TextBackground,
  'text-color': TextColor,
  'volume-2': Volume2,
  'volume-x': VolumeX,
  'user-check': UserCheck,
  'user-plus': UserPlus,
  'x-circle': XCircle,
  'zoom-in': ZoomIn,
  'zoom-out': ZoomOut,
  activity: Activity,
  ai: AI,
  anchor: Anchor,
  arrow: ArrowUp,
  arrowDownRight: ArrowDownRight,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  bank: Bank,
  bell: Bell,
  bold: Bold,
  branches: Branches,
  briefcase: Briefcase,
  calendar: Calendar,
  camera: Camera,
  check: Check,
  chevron: ChevronDown,
  circle: Circle,
  clipboard: Clipboard,
  clock: Clock,
  close: X,
  copy: Copy,
  cornerDownRight: CornerDownRight,
  cornerRightDown: CornerRightDown,
  crop: Crop,
  debug: Debug,
  delete: Delete,
  desktop: Monitor,
  dollar: DollarSign,
  dropdown: Dropdown,
  droplet: Droplet,
  edit: Edit,
  error: Slash,
  exclamation: AlertTriangle,
  externalLink: ExternalLink,
  eye: Eye,
  file: File,
  flag: Flag,
  flow: GitPullRequest,
  funda: Funda,
  gear: Settings,
  globe: Globe,
  grid: Grid,
  home: Home,
  hypotheekbond: Hypotheekbond,
  image: Image,
  incomingLink: IncomingLink,
  incomingUser: IncomingUser,
  indent: Indent,
  intercom: Intercom,
  info: Info,
  italic: Italic,
  key: Key,
  layer: Layers,
  layout: Layout,
  lfaCalendarIcon: LfaCalendarIcon,
  link: Link,
  list: List,
  loading: Loading,
  lock: Lock,
  mail: Mail,
  map: Map,
  maximize: Maximize,
  menu: Menu,
  minimize: Minimize,
  minimize2: Minimize2,
  minus: Minus,
  minusSquare: MinusSquare,
  number: Hash,
  office: Office,
  outdent: Outdent,
  outgoingUser: OutgoingUser,
  pause: Pause,
  pencil: Edit3,
  phone: Phone,
  phoneOutgoing: PhoneOutgoing,
  pin: Pin,
  play: Play,
  plus: Plus,
  plusSquare: PlusSquare,
  quote: Quote,
  redo: Redo,
  reload: RefreshCcw,
  repeat: Repeat,
  reply: Reply,
  save: Save,
  search: Search,
  send: Send,
  share: Share,
  shield: Shield,
  slash: Slash,
  sliders: Sliders,
  spinner: Spinner,
  square: Square,
  star: Star,
  tag: Tag,
  trashcan: Trash2,
  triangle: Triangle,
  truck: Truck,
  trustoo: TrustooEmblem,
  type: Type,
  typography: Typography,
  umbrella: Umbrella,
  underline: Underline,
  undo: Undo,
  unlock: Unlock,
  upload: Upload,
  user: User,
  users: Users,
  userX: UserX,
  widgetIcon: WidgetIcon,
  zap: Zap,
};

export default icons;
